import { CategoryResponse } from "@/main/models/response";
import { SubcategoryRequest } from "@/main/models/request/subcategoryRequest";
import { IInitialReducerData } from "@/main/services/reducerUtils";

export enum SubcategoryTypes {
	GET_SUBCATEGORY = "@subcategory/GET_SUBCATEGORY",
	SAVE_SUBCATEGORY = "@subcategory/SAVE_SUBCATEGORY",
	RESET_REDUCER_SUBCATEGORY = "@subcategory/RESET_REDUCER_SUBCATEGORY",
}

export interface SubcategoryState {
	readonly subcategory: {
		data: CategoryResponse[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly isolated: {
		[key: string]: IInitialReducerData;
	};
}

export interface GetSubcategory {
	type: typeof SubcategoryTypes.GET_SUBCATEGORY;
	payload: {
		request: SubcategoryRequest;
		keyReducer: string;
	};
}

export interface SaveSubcategory {
	type: typeof SubcategoryTypes.SAVE_SUBCATEGORY;
	payload: {
		data: CategoryResponse[] | null;
		isError: boolean;
		errorMessages: string[] | null;
		keyReducer: string;
	};
}

export interface ResetReducerSubcategory {
	type: typeof SubcategoryTypes.RESET_REDUCER_SUBCATEGORY;
	payload: {
		keyReducer: string;
	};
}

export type SubcategoryActionTypes = GetSubcategory | SaveSubcategory | ResetReducerSubcategory;
